/**
 * Whether this page is running inside the OLS Mail desktop app (`desktop/`,
 * ADR 0051).
 *
 * The app defines `window.__OLS_DESKTOP__` from an initialization script
 * before this bundle runs. It is a page-visible global that any script could
 * define as well, so it is a hint for copy and cosmetics only and must never
 * feed anything security-relevant. Nothing needs it to: the desktop app's
 * boundary lives in the app itself (its IPC ACL and navigation lock), not in
 * anything this page believes about where it is running.
 */

export interface DesktopApp {
  /** The desktop app's own version, not the web app's. */
  version: string;
  /** `linux`, `windows` or `macos`. */
  platform: string;
}

declare global {
  interface Window {
    __OLS_DESKTOP__?: DesktopApp;
  }
}

export function desktopApp(): DesktopApp | null {
  if (typeof window === 'undefined') return null;
  const value = window.__OLS_DESKTOP__;
  return value && typeof value.version === 'string' ? value : null;
}

export function isDesktopApp(): boolean {
  return desktopApp() !== null;
}
